module.exports = __webpack_public_path__ + "static/media/Slice31@2x.5508f907.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice31@2x.png
// module id = 1462
// module chunks = 0